import { useCallback, useState } from 'react';

export interface NotificationState {
  open: boolean;
  message: string;
  severity: 'success' | 'error' | 'info' | 'warning';
}

export const useNotification = () => {
  const [notification, setNotification] = useState<NotificationState>({
    open: false,
    message: '',
    severity: 'info',
  });

  const showSuccess = useCallback((message: string) => {
    setNotification({
      open: true,
      message,
      severity: 'success',
    });
  }, []);

  const showError = useCallback((message: string) => {
    setNotification({
      open: true,
      message,
      severity: 'error',
    });
  }, []);

  const showInfo = useCallback((message: string) => {
    setNotification({
      open: true,
      message,
      severity: 'info',
    });
  }, []);

  const showWarning = useCallback((message: string) => {
    setNotification({
      open: true,
      message,
      severity: 'warning',
    });
  }, []);

  const hideNotification = useCallback(() => {
    setNotification((prev) => ({
      ...prev,
      open: false,
    }));
  }, []);

  return {
    notification,
    showSuccess,
    showError,
    showInfo,
    showWarning,
    hideNotification,
  };
};
